// extracted by mini-css-extract-plugin
export default {"hr-line":"Experties_hr-line__F8j2x","h1-border__style":"Experties_h1-border__style__gOw9d","custom-card":"Experties_custom-card__O6pLq"};